import React from 'react';

export default function StepsBlock({ content = {} }) {
  const items = content.items || [];
  if (!items.length && !content.headline) return null;

  return (
    <section className="py-8 px-4 sm:px-0">
      {content.headline && (
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 text-center mb-8">
          {content.headline}
        </h2>
      )}
      <ol className="space-y-6">
        {items.map((item, index) => (
          <li key={index} className="flex gap-4">
            <span
              className="shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm"
              style={{ backgroundColor: '#00AAFF' }}
            >
              {item.number ?? index + 1}
            </span>
            <div>
              {item.title && (
                <h3 className="font-semibold text-gray-900 mb-1">{item.title}</h3>
              )}
              {item.description && (
                <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
              )}
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
